// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer24Filled: FC<Offer24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M11.162 22c-.25 0-.501-.05-.752-.15a2 2 0 0 1-.675-.45l-7.16-7.15c-.2-.2-.346-.42-.437-.662a2.062 2.062 0 0 1 0-1.488c.091-.25.237-.475.438-.675l8.81-8.825c.184-.183.401-.33.652-.438.25-.108.508-.162.775-.162h7.184c.551 0 1.023.196 1.415.587C21.804 2.98 22 3.45 22 4v7.175a1.973 1.973 0 0 1-.576 1.4L12.588 21.4a2 2 0 0 1-.676.45c-.25.1-.5.15-.75.15Zm6.332-14a1.45 1.45 0 0 0 1.064-.438c.292-.291.438-.645.438-1.062 0-.417-.146-.77-.438-1.063A1.45 1.45 0 0 0 17.494 5a1.45 1.45 0 0 0-1.064.438 1.446 1.446 0 0 0-.438 1.062c0 .417.146.77.438 1.063A1.45 1.45 0 0 0 17.494 8Z" />
        </svg>
    );
};

export default Offer24Filled;
